import { useEffect } from "react";
import ApiService from "../services/api";

const PROJECT_URL = import.meta.env.VITE_PROJECT_URL;
const COUNTRY_REDIRECT_LIST = new Set([
  "india",
  "pakistan",
  "nepal",
  "bhutan",
  "bangladesh",
]);


const normalize = (value?: string | null) => value?.trim().toLowerCase() || "";
const getRedirectUrlByCountry = () => {
  const currentRoute = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return new URL(currentRoute, PROJECT_URL).toString();
};

const isSupportedPath = (path: string) =>
  path === "/" || path.startsWith("/customer") || path.startsWith("/distributor");

const redirectIfTargetCountry = (country: string) => {
  if (country && COUNTRY_REDIRECT_LIST.has(country)) {
    window.location.replace(getRedirectUrlByCountry());
    return false;
  }
  return false;
};

export const performCountryRedirectIfNeeded = async (): Promise<boolean> => {
  if (!PROJECT_URL?.trim()) return false;

  const path = window.location.pathname.toLowerCase();
  if (!isSupportedPath(path)) return false;

  try {
    const apiService = new ApiService();
    const detectedCountry = await apiService.getCountryNameFromIp();
    const country = normalize(detectedCountry);
    return redirectIfTargetCountry(country);
  } catch (error) {
    console.error("Failed to detect country for route redirect:", error);
    return false;
  }
};

export const useCountryRedirect = () => {
  useEffect(() => {
    void performCountryRedirectIfNeeded();
  }, []);
};
